import Vue from 'vue'
import to from 'await-to-js'
import store from '@/config/vuex'
import client from '@/api/client'
import preFilledNewsletterCheckboxQuery from '@/api/gql/_shared/email-subscription/query/pre-filled-newsletter-checkbox.gql'
import registerToMailingListMutation from '@/api/gql/_shared/email-subscription/mutation/register-to-mailing-list.gql'

const EmailSubscriptionService = {
  async preFilledNewsletterCheckbox(email) {
    const [error, result] = await to(
      client.query({
        query: preFilledNewsletterCheckboxQuery,
        variables: { email },
        fetchPolicy: 'network-only',
      })
    )
    if (!error) {
      store.commit('emailSubscriptions/addEmailSubscriptions', result.data)
    }
  },

  async registerToMailingList(variables) {
    const [error, result] = await to(
      client.mutate({ mutation: registerToMailingListMutation, variables })
    )
    if (error) {
      Vue.rollbar.error(error)
      return false
    }
    return !!result?.data?.registerToMailingList?.success
  },
}

export default EmailSubscriptionService
